<div class="wrapper">
  <div class="quantity-input">
    <app-number-input
      [error]="form?.controls?.quantity?.errors?.required ? 'This field is required' : null"
      [isDecimalAllowed]="true"
      [label]="'RECEIVED (' + uom + ')'"
      [parentFormGroup]="form"
      class="mb-[20px]"
      controlName="quantity"
      />
  </div>

  @if (customFields?.length > 0) {
    <div class="fields-row input-block">
      @for (field of customFields; track field) {
        @if (field.type === 'string' || false) {
          <app-text-input
            [controlName]="field.id"
            [label]="field.label"
            [parentFormGroup]="form"
            />
        }
        @if (field.type === 'number' || false) {
          <app-number-input
            [controlName]="field.id"
            [label]="field.label"
            [parentFormGroup]="form"
            />
        }
      }
    </div>
  }
  @if (!!form.controls['comment']) {
    <div
      class="comment-section"
      >
      <app-text-area
        [parentFormGroup]="form"
        controlName="comment"
        label="COMMENT"
        />
    </div>
  }
  @if (selectedMediaFiles.length) {
    <app-pictures-section
      (onDelete)="deletePicture($event)"
      [pictures]="selectedMediaFiles"
      class="pictures-section"
      />
  }
  @if (showLocationSection()) {
    <app-location-station-card
      (onDelete)="deleteLocation()"
      [latitude]="form?.controls?.latitude?.value"
      [longitude]="form?.controls?.longitude?.value"
      [locationText]="form?.controls?.location?.value"
      [stationRange]="form?.controls?.station_range?.value"
      [form]="form"
      [recordLabel]="'delivery'"
      class="location-section"
      />
  }
</div>
